import React, { PropsWithChildren, useState } from 'react';
import { useFeatureServices } from '../hooks/use-feature-services';
import { MaintenanceContext } from '../hooks/use-maintenance-context';
import { translation } from '../lang/translation';
import { LangType } from '../typings/lang';
import { MaintenanceContextType } from '../typings/maintenance-app';

export const MaintenanceContextProvider = (props: PropsWithChildren) => {
  const { 'locale-service': localeService } = useFeatureServices();
  const localeLang = localeService.language as LangType;

  const [lang, setLang] = useState<LangType>(localeLang);

  const translationHandler = (key: string): string => {
    return translation(lang, key);
  };

  const MaintenanceContextValue: MaintenanceContextType = {
    translationHandler,
    lang: {
      value: lang,
      set: setLang,
    },
  };

  return (
    <MaintenanceContext.Provider value={MaintenanceContextValue}>
      {props.children}
    </MaintenanceContext.Provider>
  );
};
